import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import {
  CouponDTO,
  FindCouponFilterDTO,
  Request,
} from "@campgladiator/cg-common.types.types";
import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";
import { generateQueryString } from "@campgladiator/cg-common.utility.objects";

export const fetchCoupons = async (
  args?: FindCouponFilterDTO
): Promise<CouponDTO[]> => {
  try {
    const endpoint = "/library/v1/coupons";
    const params = args ? `?${generateQueryString(args)}` : undefined;
    const method = "GET";
    const request: Request = {
      requestConfig: {
        method,
        url: {
          baseUrl: getApiGatewayUrl(),
          endpoint,
          params,
        },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();

    return response.ok
      ? (result.content as CouponDTO[])
      : Promise.reject(new Error(result.error));
  } catch (error) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || "An unknown error occurred";

    throw new Error(errorMessage as string);
  }
};
